import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { CargosService } from '../../../../Cargos/cargos.service';
import { ConcessionariasService } from '../../../../Persona/Concessionarias/concessionarias.service';
import { MeurhVagasService } from '../../../Vagas/vagas.service';
import { EstabelecimentosService } from '../../../../Estabelecimentos/estabelecimentos.service';
import { TrabalhadoresService } from '../../../../Trabalhadores/trabalhadores.service';
import { MeurhAdmissaoestagiarioService } from '../../admissaoestagiario.service';
import { IGestoresTrabalhador } from '../../../Transferenciacolaboradores/models/transferenciacolaboradores.model';
import { Usuarios } from '../../../../../shared/services/usuarios.service';
import {
    CHAVE_DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF,
    CHAVE_LIBERAR_EMAIL_CORPORATIVO_AUTOMATICO_CPF,
    DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF_PADRAO,
    normalizarDominio,
    sugestaoEmailCorporativoTela,
} from '../../../../../shared/services/email-corporativo-automatico';
import { HorarioDetalhadoModalService } from '../../../Admissao/modais/modal-horario-detalhado/horario-detalhado.modal.service';
import { HorariosService } from '../../../../Horarios/horarios.service';
import { VinculoCpfModalService } from '../../../Admissao/modais/modal-vinculo-cpf/vinculo-cpf.modal.service';
import { IVinculoCpfAdmissao } from '../../../Admissao/models/vinculo-cpf-admissao.model';
import { SituacaoAdmissaoEnum } from '../../enums/situacao';

export class MeurhAdmissoesestagiarioDadosgeraisFormController implements ng.IController {

    static $inject = [
        'CargosService',
        'MeurhVagasService',
        'EstabelecimentosService',
        'TrabalhadoresService',
        'HorarioDetalhadoModalService',
        'HorariosService',
        '$scope',
        '$rootScope',
        '$window',
        'ConcessionariasService',
        'MeurhAdmissaoestagiarioService',
        'NewToaster',
        'Usuarios',
        'VinculoCpfModalService',
    ];

    public busy: boolean;
    public entity: any;
    public action: string;
    public form: angular.IFormController;
    public constructor_: any = {};
    public empresa: any;
    public carregaHorarios: any;
    public desativaportrabalhadortemporario: boolean = false;
    public matriculaAutomatica: boolean = false;
    public listaTrabalhadores: any;
    public vagaSelecionada: boolean = false;
    public nivelSelecionado: boolean = false;
    public mostraobrigatoriosencaminhar: boolean;
    public listagemPermissaoGestores: string[] = ['visualizar_admissao'];

    // inicio - tratamento de datas
    public anoMaximo: moment.Moment;
    public anoMinimo: moment.Moment;
    public mesInit: moment.Moment;
    // fim - tratamento de datas

    public usuarioGestor: boolean;
    public dadosUsuarioProfile;
    public isAdmin: boolean;

    // campos da admissão bloqueados individualmente quando a vaga predefinida já traz a
    // informação preenchida; os que não foram preenchidos na vaga seguem habilitados
    public camposBloqueadosVaga: { [campo: string]: boolean } = {};

    // sugestão do e-mail corporativo no padrão cpf@domínio (LIBERAR_ADMISSAO_EMAIL_CORPORATIVO_AUTOMATICO_CPF)
    public sugestaoEmailCorporativoAtiva: boolean = false;
    public dominioEmailCorporativo: string = DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF_PADRAO;

    // sugestão do e-mail corporativo no padrão cpf@domínio (LIBERAR_ADMISSAO_EMAIL_CORPORATIVO_AUTOMATICO_CPF)
    public sugestaoEmailCorporativoAtiva: boolean = false;
    public dominioEmailCorporativo: string = DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF_PADRAO;

    // avisos de recontratação/duplicidade exibidos durante o preenchimento (apenas informativos)
    // matrícula verificada que já está em uso na empresa
    public matriculaEmUso: string | null = null;
    public vinculoCpf: IVinculoCpfAdmissao | null = null;

    public sugestoesCargo: {
        departamento: any,
        lotacao: any,
        horario: any,
    } = {
        departamento: null,
        lotacao: null,
        horario: null,
    };

    private camposVaga: Array<string> = [
        'cargo',
        'nivelcargo',
        'departamento',
        'lotacao',
        'ambiente',
        'condicaoambientetrabalho',
        'grupodeponto',
        'valorbolsa',
        'unidadebolsa',
        'horario',
    ];

    private ultimaMatriculaVerificada: string | null = null;
    private ultimoCpfVerificado: string | null = null;

    private toastTimeout: number = 8000;
    private ultimaSugestaoEmailCorporativo: string | null = null;

    constructor(
        public CargosService: CargosService,
        public MeurhVagasService: MeurhVagasService,
        public EstabelecimentosService: EstabelecimentosService,
        public TrabalhadoresService: TrabalhadoresService,
        public HorarioDetalhadoModalService: HorarioDetalhadoModalService,
        public HorariosService: HorariosService,
        private $scope: angular.IScope,
        private $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            configuracoes: any,
            session: any,
            nsjGlobals: any,
            isAdmin: any
        },
        private $window: ng.IWindowService,
        private ConcessionariasService: ConcessionariasService,
        private MeurhAdmissaoestagiarioService: MeurhAdmissaoestagiarioService,
        private NewToaster: any,
        private Usuarios: Usuarios,
        private VinculoCpfModalService: VinculoCpfModalService,
    ) {
        this.TrabalhadoresService.constructors['tipo'] = '1'; // colaborador contribuinte
        this.listaTrabalhadores = this.TrabalhadoresService.reload();
        this.$scope.$on('meurh_vagas_list_finished', (event: any, args: any) => {
            if (args.length > 0 && this.action === 'insert') {
                this.entity.vagaAtiva = true;
            } else {
                this.entity.vagaAtiva = false;
            }
            this.busy = false;
            this.$rootScope.$broadcast('vaga_ativa_load_finished');
        });

        this.$scope.$watch('$ctrl.entity.cpf', (newValue?: string, oldValue?: string) => {
            if (newValue !== oldValue) {
                const dependentes = this.entity.dependentes ?? [];
                const isCpfUtilizado = dependentes.some((dependente: { cpf: string })  => (
                    dependente.cpf === this.entity.cpf
                ));
                this.form.cpf.$setValidity('cpfUsado', !isCpfUtilizado);
            }
        }, true);

        // cobre digitação, leitura de documento (OCR) e CPF já preenchido na carga
        this.$scope.$watch('$ctrl.entity.cpf', (cpf?: string) => {
            this.verificaVinculoCpf(cpf);
        });

        this.sugestaoEmailCorporativoAtiva = this.$rootScope.liberadoTela(CHAVE_LIBERAR_EMAIL_CORPORATIVO_AUTOMATICO_CPF);
        if (this.sugestaoEmailCorporativoAtiva) {
            this.dominioEmailCorporativo = normalizarDominio(this.$rootScope.configuracoes?.[CHAVE_DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF])
                || DOMINIO_EMAIL_CORPORATIVO_AUTOMATICO_CPF_PADRAO;

            // cobre digitação e CPF já preenchido na carga
            this.$scope.$watch('$ctrl.entity.cpf', (cpfNovo?: string, cpfAnterior?: string) => {
                this.sugerirEmailCorporativo(cpfNovo, cpfAnterior);
            });
        }

        this.isAdmin = $rootScope.nsjGlobals.get('isAdmin');

        // se usuário tiver alguma dessas permissões, é gestor
        this.usuarioGestor = $rootScope.nsjGlobals.get('permissoes')['visualizar_admissao'] ||
            $rootScope.nsjGlobals.get('permissoes')['visualizar_admissao_comp'] ||
            $rootScope.nsjGlobals.get('permissoes')['visualizar_admissaoestagiario'];

    }

    async $onInit(): Promise<void> {
        this.constructor_ = this.verificacaoCargo();

        // if (this.entity.situacao !== -1) {
        this.empresa = this.$rootScope.session.entities.empresa.empresa;
        this.carregaHorarios = true;
        // }

        if (this.$rootScope.configuracoes.CODIGO_FUNCIONARIO_AUTOMATICO === true) {
            this.matriculaAutomatica = true;
            this.entity.matricula = '';
        }

        this.preencheCampoEstabelecimento();
        this.calculaMes();
        this.bloqueiaQuatorzeanos();
        this.bloqueiaAnoMinimo();
        this.verificaGestores();
        this.verificaVagaAtiva();

        // se estiver visualizando/editando admissão, precisa fazer get de horário para obter o resumo da jornada semanal
        if (this.action !== 'insert' && this.entity?.horario) {

            await this.HorariosService.get(this.entity.horario.horario, true).then((horarioBuscado) => {
                this.entity.horario = horarioBuscado;
            })
            .catch((error) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não foi possível carregar o horário'
                });
            });

        }

        // se for uma inserção, o usuário logado for um gestor e não for admin
        if (this.action === 'insert' && this.usuarioGestor && !this.isAdmin) {

            // pegando as informações do usuário no profile
            this.dadosUsuarioProfile = await this.Usuarios.getProfile();

            // buscando dados de gestor do usuário logado
            let dadosTrabalhador: any = await this.buscaDadosGestorUsuarioLogado();

            // atribuindo os dados do usuário logado como gestor único
            this.entity.gestores = [{
                email: dadosTrabalhador.identificacaonasajon,
                gestor: dadosTrabalhador.trabalhador,
                nome: dadosTrabalhador.nome,
                tipoGestor: 'Interno'
            }];

        }

        // necessário para exibir os campos horas por mês e horas por semana corretamente como números
        if ((this.action === 'show' || this.action === 'update') && (this.entity.numerohorasmensais || this.entity.quantidademediahorassemanais)) {

            if (this.entity.numerohorasmensais) {
                const parsedHorasMensais = this.parseDecimal(this.entity.numerohorasmensais);
                if (parsedHorasMensais !== null) {
                    this.entity.numerohorasmensais = parsedHorasMensais;
                }
            }

            if (this.entity.quantidademediahorassemanais) {
                const parsedHorasSemanais = this.parseDecimal(this.entity.quantidademediahorassemanais);
                if (parsedHorasSemanais !== null) {
                    this.entity.quantidademediahorassemanais = parsedHorasSemanais;
                }
            }

        }

        this.validateHorasMensais();
        this.validateHorasSemanais();

        if (this.action === 'update') {
            this.verificaMatricula();
        }

    }

    public validateHorasMensais(): void {
        if (!this.form || !this.form.numerohorasmensais) {
            return;
        }

        const rawValue = this.entity.numerohorasmensais;
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            this.form.numerohorasmensais.$setValidity('number', true);
            this.form.numerohorasmensais.$setValidity('min', true);
            this.form.numerohorasmensais.$setValidity('max', true);
            return;
        }

        const parsed = this.parseDecimal(rawValue);
        const isNumber = parsed !== null;

        this.form.numerohorasmensais.$setValidity('number', isNumber);
        if (isNumber) {
            this.form.numerohorasmensais.$setValidity('min', parsed >= 1);
            this.form.numerohorasmensais.$setValidity('max', parsed <= 150);
        } else {
            this.form.numerohorasmensais.$setValidity('min', true);
            this.form.numerohorasmensais.$setValidity('max', true);
        }
    }

    public validateHorasSemanais(): void {
        if (!this.form || !this.form.quantidademediahorassemanais) {
            return;
        }

        const rawValue = this.entity.quantidademediahorassemanais;
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            this.form.quantidademediahorassemanais.$setValidity('number', true);
            this.form.quantidademediahorassemanais.$setValidity('min', true);
            this.form.quantidademediahorassemanais.$setValidity('max', true);
            return;
        }

        const parsed = this.parseDecimal(rawValue);
        const isNumber = parsed !== null;

        this.form.quantidademediahorassemanais.$setValidity('number', isNumber);
        if (isNumber) {
            this.form.quantidademediahorassemanais.$setValidity('min', parsed >= 1);
            this.form.quantidademediahorassemanais.$setValidity('max', parsed <= 30);
        } else {
            this.form.quantidademediahorassemanais.$setValidity('min', true);
            this.form.quantidademediahorassemanais.$setValidity('max', true);
        }
    }

    calculaDatas(): void {
        this.entity.inicioperiodoaquisitivoferias = moment(this.entity.datainiciocontrato);
    }

    verificacaoCargo(): { cargo: string | null } {
        if (this.entity.cargo) {
            if (this.entity.cargo.cargo) {
                return { 'cargo': this.entity.cargo.cargo };
            }
        }
        return { 'cargo': null };
    }

    verificaEstabelecimento(): { estabelecimento: string } {
        if (this.entity.estabelecimento) {
            return { 'estabelecimento': this.entity.estabelecimento };
        } else {
            return { 'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento };
        }
    }

    verificaVagaAtiva(): void {
        if (!this.entity.vaga) {
            this.busy = true;
            this.MeurhVagasService.reload();
        } else {
            this.entity.vagaAtiva = true;
            this.vagaSelecionada = true;
            // enquanto a vaga não é relida, mantém todos os campos bloqueados
            this.defineBloqueioCamposVaga(true);
            this.carregaBloqueiosVaga();

            this.$rootScope.$broadcast('vaga_ativa_load_finished');
        }
    }

    // a admissão persiste apenas o identificador da vaga, então é preciso relê-la para
    // saber quais campos foram de fato preenchidos no cadastro da vaga
    carregaBloqueiosVaga(): void {
        // na visualização todos os campos já ficam bloqueados pela própria action
        if (this.action === 'show') {
            return;
        }

        const vaga = this.entity.vaga.vaga ? this.entity.vaga.vaga : this.entity.vaga;

        this.MeurhVagasService.get(vaga)
            .then((response: any): void => {
                this.montaCamposBloqueadosVaga(response);
            })
            .catch((e: any): void => {
                console.error(e);
            });
    }

    // um campo só é considerado preenchido na vaga quando tem valor útil
    campoVagaPreenchido(valor: any): boolean {
        if (valor === null || valor === undefined || valor === '') {
            return false;
        }

        if (Array.isArray(valor)) {
            return valor.length > 0;
        }

        return true;
    }

    // salário/bolsa não informado na vaga pode chegar como nulo ou como zero
    campoVagaValorPreenchido(valor: any): boolean {
        return this.campoVagaPreenchido(valor) && parseFloat(valor) > 0;
    }

    montaCamposBloqueadosVaga(vaga: any): void {
        this.camposBloqueadosVaga = {
            // em vagas, não há o campo exclusivo de cargo (ele fica dentro do nível cargo)
            cargo: this.campoVagaPreenchido(vaga.nivelcargo && vaga.nivelcargo.cargo),
            nivelcargo: this.campoVagaPreenchido(vaga.nivelcargo),
            departamento: this.campoVagaPreenchido(vaga.departamento),
            lotacao: this.campoVagaPreenchido(vaga.lotacao),
            ambiente: this.campoVagaPreenchido(vaga.ambiente),
            condicaoambientetrabalho: this.campoVagaPreenchido(vaga.condicaoambientetrabalho),
            grupodeponto: this.campoVagaPreenchido(vaga.grupodeponto),
            // em vagas, a bolsa do estagiário corresponde ao salário fixo
            valorbolsa: this.campoVagaValorPreenchido(vaga.salariofixo),
            unidadebolsa: this.campoVagaValorPreenchido(vaga.salariofixo),
            horario: this.campoVagaPreenchido(vaga.horario),
        };
    }

    defineBloqueioCamposVaga(bloqueado: boolean): void {
        this.camposBloqueadosVaga = {};
        this.camposVaga.forEach((campo: string): void => {
            this.camposBloqueadosVaga[campo] = bloqueado;
        });
    }

    verificaGestores(): void {
        if (!this.entity.gestores) {
            this.entity.gestores = [];
        }

        if (this.action === 'update' || this.action === 'show') {
            this.entity.gestores.map((gestor: IGestoresTrabalhador) => {
                if (gestor.identificacaonasajongestor) {
                    gestor.nome = '';
                    gestor.tipoGestor = 'Externo';
                    gestor.email = gestor.identificacaonasajongestor;
                } else {
                    gestor.nome = gestor.trabalhador!['nome'];
                    gestor.tipoGestor = 'Interno';
                    gestor.email = gestor.trabalhador!['identificacaonasajon'];
                    gestor.gestor = gestor.trabalhador!['trabalhador'];
                }
            });
        }
    }

    alteraNivelPorCargo(): void {
        if (this.entity.cargo) {
            this.$rootScope.$broadcast('nivelcargo_refresh', { cargo: this.entity.cargo.cargo });
            this.entity.nivelcargo = null;
        }
    }

    alteraVaga(): void {
        if (this.entity.vaga) {
            this.busy = true;
            this.MeurhVagasService.get(this.entity.vaga.vaga)
                .then((response: any): void => {
                    this.vagaSelecionada = true;
                    this.preencheCamposVaga(response);
                })
                .catch((e: any): void => {
                    this.busy = false;
                    console.error(e);
                });
        } else if (this.vagaSelecionada) {
            this.limpaCamposVaga();
        }
    }

    preencheCamposVaga(vaga: any): void {
        this.limpaCamposVaga();
        this.entity.vaga = vaga;
        this.montaCamposBloqueadosVaga(vaga);

        if (this.camposBloqueadosVaga.departamento) {
            this.entity.departamento = vaga.departamento;
        }

        if (this.camposBloqueadosVaga.lotacao) {
            this.entity.lotacao = vaga.lotacao;
        }

        if (this.camposBloqueadosVaga.nivelcargo) {
            this.entity.nivelcargo = vaga.nivelcargo;
        }

        // a unidade salarial sempre vem preenchida da vaga, porque o cadastro assume "mês"
        // por padrão; por isso ela é carregada como sugestão e o bloqueio segue o valor
        if (this.campoVagaPreenchido(vaga.unidadesalariofixo)) {
            this.entity.unidadebolsa = vaga.unidadesalariofixo.toString();
        }

        if (this.camposBloqueadosVaga.valorbolsa) {
            this.entity.valorbolsa = vaga.salariofixo;
        }

        if (this.camposBloqueadosVaga.grupodeponto) {
            this.entity.grupodeponto = vaga.grupodeponto;
        }

        if (this.camposBloqueadosVaga.ambiente) {
            this.entity.ambiente = vaga.ambiente;
        }

        if (this.camposBloqueadosVaga.condicaoambientetrabalho) {
            this.entity.condicaoambientetrabalho = vaga.condicaoambientetrabalho;
        }

        this.entity.beneficios = this.campoVagaPreenchido(vaga.beneficios) ? vaga.beneficios : [];
        this.entity.vts = this.campoVagaPreenchido(vaga.vts) ? vaga.vts : [];

        if ((!this.usuarioGestor || this.isAdmin) && vaga.gestores && vaga.gestores.length > 0) {
            this.entity.gestores = vaga.gestores.map((gestor: any) => {
                if (gestor.gestor.trabalhador) {
                    return gestor.gestor;
                } else {
                    return {
                        nome: gestor.identificacaonasajongestor
                    };
                }
            });
        }
        // em vagas, o nome dos atributos referente a data dos períodos são diferentes
        this.entity.beneficios.forEach((beneficio: any) => {
            if (beneficio.tipoperiodo === 1) { // todo mês (x)
                beneficio.mes = beneficio.tipoperiodomes;
            } else if (beneficio.tipoperiodo === 2) { // entre mês/ano
                beneficio.mesinicial = beneficio.tipoperiodomesinicio;
                beneficio.mesfinal = beneficio.tipoperiodomesfinal;
                beneficio.anoinicial = beneficio.tipoperiodoanoinicio;
                beneficio.anofinal = beneficio.tipoperiodoanofinal;
            }
            beneficio.usobeneficio = 1;
            beneficio.nomepessoa = this.entity.nome;
        });

        // em vagas, não há o campo exclusivo de concessionária (ela fica dentro da tarifa)
        this.entity.vts.forEach((vt: any) => {
            this.ConcessionariasService.get(vt.tarifaconcessionariavt.concessionariavt)
                .then((response: any) => {
                    vt.concessionariavt = response;
                });
        });
        // em vagas, não há o campo exclusivo de cargo (ele fica dentro do nível cargo)
        if (vaga.nivelcargo?.cargo) {
            this.CargosService.get(vaga.nivelcargo.cargo)
                .then((response: any) => {
                    this.entity.cargo = response;
                }).catch((e: any): void => {
                    console.error(e);
                }).finally(() => {
                    this.busy = false;
                });
        } else {
            this.busy = false;
        }

        if (vaga.horario?.horario) {

            this.HorariosService.get(vaga.horario.horario, true).then((horarioBuscado) => {
                this.entity.horario = horarioBuscado;
            })
            .catch((error) => {
                console.log(error);
            });

        }

        // em vagas, o campo estabelecimento é um identificador
        /*
        this.EstabelecimentosService.get(vaga.estabelecimento)
            .then((response: any) => {
                this.entity.estabelecimento = response;
            })
            .catch((e: any): void => {
                this.busy = false;
                console.error(e);
            });
        */

    }

    limpaCamposVaga(): void {
        delete this.entity.vaga;
        delete this.entity.departamento;
        delete this.entity.lotacao;
        delete this.entity.cargo;
        delete this.entity.nivelcargo;
        delete this.entity.grupodeponto;
        delete this.entity.valorbolsa;
        delete this.entity.ambiente;
        delete this.entity.condicaoambientetrabalho;
        delete this.entity.horario;
        if (!this.usuarioGestor || this.isAdmin) {
            this.entity.gestores = [];
        }
        this.entity.beneficios = [];
        this.entity.vts = [];

        this.camposBloqueadosVaga = {};

    }

    preencheCampoEstabelecimento(): void {
        if (!this.entity.estabelecimento) {
            this.entity.estabelecimento = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        }
        this.busy = true;
        this.EstabelecimentosService.get(this.entity.estabelecimento)
            .then((response: any) => {
                this.entity.estabelecimento = response;
            }).catch((e: any): void => {
                console.error(e);
            }).finally(() => {
                this.busy = false;
            });
    }

    async changeCargo(): Promise<void> {
        this.alteraNivelPorCargo();
        this.constructor_ = this.verificacaoCargo();

        if (this.entity.cargo) {

            this.busy = true;

            await this.CargosService.get(this.entity.cargo.cargo)
            .then((response: any) => {

                this.sugestoesCargo.departamento = response.departamento;
                this.sugestoesCargo.lotacao = response.lotacao;
                this.sugestoesCargo.horario = response.horario;

                // propriedades na admissão - a sugestão do cargo não pode sobrescrever o
                // que a vaga pré-definida já preencheu e bloqueou
                if (!this.camposBloqueadosVaga.departamento) {
                    this.entity.departamento = this.sugestoesCargo.departamento;
                }

                if (!this.camposBloqueadosVaga.lotacao) {
                    this.entity.lotacao = this.sugestoesCargo.lotacao;
                }

            }).catch((e: any): void => {
                console.error(e);
            }).finally(() => {
                this.busy = false;
            });

            // se houver horário preenchido no cargo, buscar os dados dele para preencher campo na admissão adequadamente
            if (!this.camposBloqueadosVaga.horario) {

                if (this.sugestoesCargo.horario) {

                    this.HorariosService.get(this.sugestoesCargo.horario.horario, true).then((horarioBuscado) => {
                        this.entity.horario = horarioBuscado;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

                } else {
                    this.entity.horario = null;
                }

            }

        } else {

            // limpando as sugestões
            this.sugestoesCargo = {
                departamento: null,
                lotacao: null,
                horario: null,
            };

            // limpando os campos da admissão - exceto os que a vaga pré-definida travou
            if (!this.camposBloqueadosVaga.departamento) {
                this.entity.departamento = null;
            }

            if (!this.camposBloqueadosVaga.lotacao) {
                this.entity.lotacao = null;
            }

            if (!this.camposBloqueadosVaga.horario) {
                this.entity.horario = null;
            }

        }

    }

    public alteraLotacao(): void {
        if (this.entity.lotacao) {
            this.$rootScope.$broadcast('ambiente_refresh', { lotacao: this.entity.lotacao.lotacao });
            this.entity.ambiente = null;
            this.entity.condicaoAmbiente = null;
        }
    }

    public alteraAmbiente(): void {
        if (this.entity.ambiente) {
            this.$rootScope.$broadcast('condicoesambientestrabalho_refresh', { ambiente: this.entity.ambiente.ambiente });
            this.entity.condicaoambientetrabalho = null;
        }
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    public preenchercamposNivel(): void {
        // o valor definido na vaga pré-definida prevalece sobre o do nível
        if (this.camposBloqueadosVaga.valorbolsa) {
            return;
        }

        if (this.entity.nivelcargo) {
            this.nivelSelecionado = true;
            this.entity.valorbolsa = this.entity.nivelcargo.valorsalario;
        } else if (this.nivelSelecionado) {
            delete this.entity.valorbolsa;
        }
    }

    public scrollToField(fieldId: string) {
        var element = this.$window.document.getElementById(fieldId);

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    public verificaLotacao(): { lotacao?: string } {
        if (!this.entity.lotacao) {
            return {};
        }
        return { 'lotacao': this.entity.lotacao!.lotacao };
    }

    public verificaAmbiente(): { ambiente?: string } {
        if (!this.entity.ambiente) {
            return {};
        }
        return { 'ambiente': this.entity.ambiente!.ambiente };
    }

    // início - funções para CPF
    public funcoesCPF(): void {
        this.preenchePix();
    }

    public preenchePix(): void {
        if (this.entity.tiporecebimentobolsa === '128') { // cpf
            this.entity.chavepix = this.entity.cpf;
        }
    }

    public abrirDetalhesVinculoCpf(): void {
        this.VinculoCpfModalService.open(this.ultimoCpfVerificado, this.vinculoCpf);
    }

    public verificaMatricula(): void {
        const matricula = (this.entity.matricula || '').trim();

        if (matricula === this.ultimaMatriculaVerificada) {
            return;
        }

        this.ultimaMatriculaVerificada = matricula;
        this.matriculaEmUso = null;

        if (!this.podeVerificarVinculos() || this.matriculaAutomatica || !matricula) {
            return;
        }

        this.MeurhAdmissaoestagiarioService.verificarMatricula(matricula, this.entity.solicitacao)
            .then((resposta: { existe: boolean }) => {
                if (matricula === this.ultimaMatriculaVerificada) {
                    this.matriculaEmUso = resposta.existe ? matricula : null;
                }
            })
            .catch(() => {
                this.ultimaMatriculaVerificada = null;
            });
    }
    // fim - funções para CPF

    public abrirModalHorarioDetalhado() {

        let modal = this.HorarioDetalhadoModalService.open(this.entity.horario, {
            empresa: this.empresa,
            estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento,
            action: this.camposBloqueadosVaga.horario ? 'show' : this.action
        });

        modal.result.then((horarioSelecionadoModal: any): void => {
            this.entity.horario = horarioSelecionadoModal;
        })
        .catch((error: any): void => {/**/});
    }

    // inicio - tratamento de datas
    // só durante o preenchimento: inclusão ou edição de admissão ainda não enviada
    private podeVerificarVinculos(): boolean {
        const emPreenchimento = this.action === 'insert'
            || (this.action === 'update' && this.entity.situacao === SituacaoAdmissaoEnum.ABERTA);

        return emPreenchimento && !this.entity.retificacao;
    }

    private verificaVinculoCpf(cpf?: string): void {
        const cpfNumeros = (cpf || '').replace(/\D/g, '');

        if (cpfNumeros === this.ultimoCpfVerificado) {
            return;
        }

        this.ultimoCpfVerificado = cpfNumeros;
        this.vinculoCpf = null;

        if (!this.podeVerificarVinculos() || cpfNumeros.length !== 11 || this.form?.cpf?.$error?.cpfInvalid) {
            return;
        }

        this.MeurhAdmissaoestagiarioService.verificarCpf(cpfNumeros, this.entity.solicitacao)
            .then((vinculo: IVinculoCpfAdmissao) => {
                // descarta a resposta se o CPF mudou enquanto a verificação estava em andamento
                if (cpfNumeros === this.ultimoCpfVerificado) {
                    this.vinculoCpf = vinculo.vinculado ? vinculo : null;
                }
            })
            .catch(() => {
                // a verificação é apenas informativa: em caso de falha, o envio continua validando no backend
                this.ultimoCpfVerificado = null;
            });
    }

    private sugerirEmailCorporativo(cpfNovo?: string, cpfAnterior?: string): void {
        if (!this.entity) {
            return;
        }

        const sugestao: string | null = sugestaoEmailCorporativoTela({
            ativa: this.sugestaoEmailCorporativoAtiva,
            action: this.action,
            cpfNovo,
            cpfAnterior,
            emailAtual: this.entity.emailcorporativo,
            ultimaSugestao: this.ultimaSugestaoEmailCorporativo,
            dominio: this.dominioEmailCorporativo,
        });

        if (sugestao) {
            this.entity.emailcorporativo = sugestao;
            this.ultimaSugestaoEmailCorporativo = sugestao;
        }
    }

    private calculaMes(): void {
        this.mesInit = moment().subtract(216, 'month'); // 18 anos
    }

    private bloqueiaQuatorzeanos(): void {
        this.anoMaximo = moment(this.mesInit).add(4, 'years'); // = 14 anos
    }

    private bloqueiaAnoMinimo(): void {
        this.anoMinimo = moment().subtract(120, 'years'); // > 120 anos
    }
    // fim - tratamento de datas

    private parseDecimal(value: any): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const normalized = String(value).replace(',', '.');
        const parsed = parseFloat(normalized);
        return Number.isNaN(parsed) ? null : parsed;
    }

    private async buscaDadosGestorUsuarioLogado() {
        let parametrosService: any = {};
        let dadosGestorLogado = {};

        parametrosService.estabelecimento = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        parametrosService.empresa = this.$rootScope.session.entities.empresa.empresa;
        parametrosService.tipo = '-1';
        parametrosService.filter = '';
        parametrosService.identificacaonasajon = this.dadosUsuarioProfile.data.email;

        await this.TrabalhadoresService.getGestoresElegiveis(parametrosService).then((listaGestores: any) => {
            // pode retornar mais de um trabalhador. Usar apenas o primeiro da lista
            dadosGestorLogado = listaGestores[0];
        }).catch((error) => {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível buscar os gestores'
            });
        }).finally(() => {
            this.busy = false;
        });

        return dadosGestorLogado;

    }

}
